import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useLocale from "../../../hooks/useLocale";
import { Typography } from "@mui/material";

const customStyles = {
  languageSwitch: {
    borderRadius: "50%",
    height: "100%",
    width: "100%",
    color: "rgba(79 189 234)",
    textAlign: "center",
    fontSize: "1rem",
    cursor: "pointer",
    border: "2px solid",
    lineHeight: "2.2rem",
  },
  arText: {
    lineHeight: "1.1rem",
    fontSize: "1.2rem",
    marginLeft: "20px",
  },
};

function LanguageSwitch() {
  const { dir } = useLocale();
  const [lang, setLang] = useState(dir === "ltr" ? "ar" : "en");
  const { t, i18n } = useTranslation();

  const handleClick = (event) => {
    const newLang = event.target.innerText === t("en") ? "ar" : "en";
    setLang(newLang);
    const isArabicLang = newLang === "ar";
    i18n.changeLanguage(isArabicLang ? "en" : "ar");
    localStorage.setItem("dir", isArabicLang ? "ltr" : "rtl");
  };

  useEffect(() => {
    const isRtlDir = dir === "rtl";
    setLang(isRtlDir ? "en" : "ar");
    i18n.changeLanguage(isRtlDir ? "ar" : "en");
  }, []);

  return (
    <Typography
      component="div"
      sx={{
        ...customStyles.languageSwitch,
        ...(lang === "ar" ? customStyles.arText : {}),
      }}
      onClick={handleClick}
    >
      <span>{t(lang)}</span>
    </Typography>
  );
}

export default LanguageSwitch;
